// test2952
(2952 && 0);
